import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ApiHelperService } from 'projects/apna-lib/src/lib/services/api-helper.service';
import { ConfigService } from 'projects/apna-lib/src/lib/services/config.service';
import { LoanGtmService } from 'projects/apna-lib/src/lib/services/loan-gtm.service';
import { UserIdentityService } from 'projects/apna-lib/src/lib/services/user-identity.service';
import mixpanel from "mixpanel-browser/src/loader-module";
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { HeaderInterface } from 'projects/apna-lib/src/lib/interfaces/common-interface';
declare let gtag: Function;

@Component({
  selector: 'fa-loan-academic-details',
  templateUrl: './loan-academic-details.component.html',
  styleUrls: ['./loan-academic-details.component.scss']
})
export class LoanAcademicDetailsComponent implements OnInit {
  model: any = {};
  dataModel: string = "users";
  isPartnerLink: boolean = false;
  partnerLogo: string;
  currentCourseType: string;
  vendorListTemplate: string;
  loading: boolean = false;
  degreeOptions = this.configService.getConfig1("foreignAssist", "degreeOptions");
  greOptions = this.configService.getConfig1("foreignAssist", "greOptions");
  gmatOptions = this.configService.getConfig1("foreignAssist", "gmatOptions");
  ieltsOptions = this.configService.getConfig1("foreignAssist", "ieltsOptions");
  toeflOptions = this.configService.getConfig1("foreignAssist", "toeflOptions");
  courseTypeOptions = this.configService.getConfig1("foreignAssist", "courseTypeOptions")

  languageTestOptions = this.configService.getConfig1("foreignAssist", "languageTestOptions");
  aptitudeTestOptions = this.configService.getConfig1("foreignAssist", "aptitudeTestOptions").reverse();
  loanWidgetConfig = this.configService.getConfig1("loanWidgetConfig")
  admissionStatusOptions = this.configService.getConfig1("foreignAssist", "admissionStatusOptions");
  pteOptions = this.configService.getConfig1("foreignAssist", "pteOptions");
  satOptions = this.configService.getConfig1("foreignAssist", "satOptions");
  actOptions = this.configService.getConfig1("foreignAssist", "actOptions");
  detOptions = this.configService.getConfig1("foreignAssist", "detOptions");
  courseDurationOptions = this.configService.getConfig1("foreignAssist", "courseDurationOptions");
  userData: { source: string; };
  orientation: String;
  step: String = "firstStep";

  configAcademicDetailsHeader: HeaderInterface = {
    title: "University and Course Details",
    back: {
      link: 'basic-information/',
      //step: 'firstStep'
    }
  }

  steps: any = this.loanWidgetConfig?.basicDetailsStepperConfig
  identify(user_id, userData = {}) {
    mixpanel.identify(user_id, userData)
  }
  trackEvent(event, data = {}) {
    mixpanel.track(event, data)
  }
  layout: FormlyFieldConfig[];

  constructor(
    public loanService: LoanGtmService,
    private route: Router,
    private configService: ConfigService,
    private userIdentity: UserIdentityService,
    private activatedRoute: ActivatedRoute,
    private apiHelper: ApiHelperService,
    public breakpointObserver: BreakpointObserver
  ) { }

  ngOnInit(): void {
    this.breakpointObserver
      .observe(['(max-width: 576px)'])
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.orientation = 'vertical';
        } else {
          this.orientation = 'horizontal';
        }
      });

    if (typeof window !== 'undefined' && !window.location.host.includes('localhost') && !window.location.host.includes('dev') && !window.location.host.includes('qa') && !window.location.host.includes('uat')) {
      mixpanel.init('36f7bc976b3c6dc024e372be5c7d26f8'); //change the token as per environment
    }
    const puid = this.activatedRoute.snapshot.paramMap.get('puid');
    if (puid) {
      this.isPartnerLink = true;
      if (!this.loanService?.partnerDetails) {
        this.getPartnerDetails(puid);
      }
      else {
        this.partnerLogo = this.loanService.partnerDetails?.company?.showCompanyLogo ? this.loanService?.partnerDetails?.company?.logo : undefined;
      }

    }
    this.checkUserLoggedIn();
    this.vendorListTemplate = this.loanService?.universityBankMessage;

    this.checkSessionStorageSteps()
  }

  checkSessionStorageSteps() {
    let stepFromSessionStorage = sessionStorage.getItem("stepHeading");

    if (stepFromSessionStorage === 'thirdStep') {
      sessionStorage.removeItem("stepHeading")
      this.step = 'thirdStep';
      let newModel = { ...this.model };
      this.model = undefined;
      this.model = newModel;
      this.steps.steps[0].status = "completed"
      this.steps.steps[1].status = "completed"
      this.steps.steps[2].status = "completed"
      this.configAcademicDetailsHeader.back = {
        link: '/academic-details',
        step: 'secondStep'
      }
    }
    else {
      this.step = "firstStep";
    }
  }

  setUniversityVendors() {
    if (this.loanService?.studentDetails?.academicDetails?.university) {
      this.apiHelper.getData(`universities`, { where: { name: this.loanService?.studentDetails?.academicDetails?.university } }).then((data: any) => {
        this.loanService.studentDetails["universityVendors"] = [...data[0]?.vendors];
      })
    }
  }

  setMobileLayout() {
    this.layout = [
      {
        fieldGroup: [
          {
            key: "academicDetails",
            fieldGroupClassName: "row mb-3",
            fieldGroup: [
              {
                className: "col-12 col-lg-6",
                fieldGroupClassName: 'row',
                fieldGroup: [
                  {
                    className: 'col-12',
                    key: 'university',
                    type: 'autocomplete',
                    templateOptions: {
                      label: 'University you are planning to go',
                      placeholder: 'Search and Choose',
                      required: true,
                      autocompleteOptions: {
                        name: 'universities',
                        value: 'name',
                        fields: ['name'],
                        dataModel: 'universities',
                        isEditable: true,
                        showTopRecords: true,
                        defaultValue: this.model?.academicDetails?.university,
                        onSelect: (item: any) => {
                          this.model.academicDetails.university = item?.name;
                          if (this.loanService?.studentDetails?.countryCode !== '+91') {
                            if (item?.vendors) {
                              let arr = item?.vendors;
                              arr = arr.filter((single: any) => {
                                return single === 'mpower' || single === 'prodigy';
                              })
                              this.loanService.studentDetails["universityVendors"] = arr;
                              this.checkVendorList(arr)
                            }
                            else {
                              this.loanService.universityBankMessage = "";
                              this.loanService.studentDetails["universityVendors"] = [];
                              delete this.loanService?.studentDetails?.universityVendors;
                            }
                          }
                          else {
                            if (item?.vendors) {
                              this.loanService.studentDetails["universityVendors"] = item?.vendors;
                              this.checkVendorList(item?.vendors)
                            }
                            else {
                              this.loanService.universityBankMessage = "";
                              this.loanService.studentDetails["universityVendors"] = [];
                              // delete this.loanService?.studentDetails?.universityVendors;
                            }
                          }

                        },
                        dataParams: {
                          aggregate: true,
                        },
                      }
                    },
                    expressionProperties: {
                      "templateOptions.autocompleteOptions.dataParams": (model: any) => {
                        let dataParams = {
                          aggregate: true,
                          where: { targetCountry: this.loanService?.studentDetails?.targetCountry },
                          limit: 10
                        }
                        return dataParams
                      }
                    },
                    hideExpression: () => {
                      return this.step !== 'firstStep'
                    }
                  },
                ]
              },

              {
                className: "col-12 col-md-6",
                key: "otherUniversity",
                type: "input",
                templateOptions: {
                  required: true,
                  placeholder: "Enter Other University Name",
                  label: "Other University"
                },
                hideExpression: () => {
                  if (this.model?.academicDetails && this.model?.academicDetails?.university) {
                    return this.model.academicDetails.university.toLowerCase() !== "other" || this.step !== 'firstStep'
                  }
                  return true;
                }
              },

              {
                className: 'col-12 col-lg-6',
                key: "courseType",
                type: 'radio',
                templateOptions: {
                  label: 'Course Type',
                  required: true,
                  placeholder: "Select course type",
                  options: this.courseTypeOptions,
                  click: () => {
                    setTimeout(() => {
                      if (this.model?.academicDetails?.courseType && this.model?.academicDetails?.courseType != this.currentCourseType) {
                        delete this.loanService?.studentDetails?.academicDetails?.course
                        this.model.academicDetails.course = undefined;
                        this.currentCourseType = this.model?.academicDetails?.courseType;
                        this.loading = true;
                        this.layout = undefined;
                        setTimeout(() => {
                          this.setMobileLayout();
                          this.loading = false;
                        }, 100)
                      }
                    }, 100)
                  }
                },
                validation: {
                  messages: {
                    required: 'Course type is required',
                  },
                },
                hideExpression: () => {
                  return this.step !== 'firstStep'
                }
              },

              {
                className: "col-12 col-lg-6",
                fieldGroupClassName: "row",
                fieldGroup: [
                  {
                    className: 'col-12',
                    key: 'course',
                    type: 'autocomplete',
                    templateOptions: {
                      label: 'Course Specialization',
                      placeholder: 'eg. Computer Science',
                      required: true,
                      autocompleteOptions: {
                        name: 'courses',
                        value: 'specialization',
                        fields: ['specialization'],
                        dataModel: 'courses',
                        isEditable: false,
                        showTopRecords: true,
                        defaultValue: this.model?.academicDetails?.course,
                        onSelect: (item: any) => {
                          this.model.academicDetails.course = item?.specialization;
                        }
                      }
                    },
                    expressionProperties: {
                      "templateOptions.autocompleteOptions.dataParams": (model: any) => {
                        if (this.model?.academicDetails?.courseType) {
                          let dataParams = {
                            aggregate: true,
                            where: { studyArea: this.model?.academicDetails?.courseType },
                            limit: 10
                          }
                          return dataParams
                        }
                        return { aggregate: true };

                      }
                    },
                    hideExpression: () => {
                      return this.step !== 'firstStep';
                    }
                  },
                ]
              },

              {
                className: "col-12 col-md-6",
                key: "otherCourse",
                type: "input",
                templateOptions: {
                  label: "Other Course",
                  placeholder: "Enter other course name",
                  required: true
                },
                hideExpression: () => {
                  if (this.model?.academicDetails && this.model?.academicDetails?.course) {
                    return this.model.academicDetails.course.toLowerCase() !== 'other' || this.step !== 'firstStep';
                  }
                  return true;
                }
              },

              {
                className: 'col-12 col-lg-6 dropdown',
                key: "courseDuration",
                type: 'select',
                templateOptions: {
                  label: 'Duration of course',
                  required: true,
                  options: this.courseDurationOptions,
                  placeholder: 'Select course Duration',
                },
                validation: {
                  messages: {
                    required: 'Course duration is required',
                  },
                },
                hideExpression: () => {
                  return this.step !== 'firstStep';
                }
              },

              {
                className: 'col-12 col-lg-6',
                key: "admissionStatus",
                type: 'select',
                templateOptions: {
                  label: 'Status of Admission',
                  required: true,
                  options: this.admissionStatusOptions,
                  placeholder: "Select admission status"
                },
                validation: {
                  messages: {
                    required: 'Admission status is required',
                  },
                },
                hideExpression: () => {
                  return this.step !== 'firstStep';
                }
              },

              {
                className: "col-6",
                key: "tenthMarks",
                type: "input",
                templateOptions: {
                  type: "number",
                  // required: true,
                  max: 100,
                  min: 30,
                  placeholder: "Enter 10th Marks",
                  label: "Enter 10th marks(%)"
                },
                validation: {
                  messages: {
                    required: '10th marks required',
                    max: "Percentage should be less than or equal to 100",
                    min: 'Percentage should be more than or equal to 30 and less than 100'
                  },
                },
                hideExpression: () => {
                  return this.step !== 'secondStep';
                },
                expressionProperties: {
                  "templateOptions.required": () => {
                    if (this.loanService?.studentDetails?.targetDegree === "Bachelors") {
                      return true;
                    }
                    else {
                      return false;
                    }
                  }
                }
              },

              {
                className: "col-6",
                key: "twelfthMarks",
                type: "input",
                templateOptions: {
                  type: "number",
                  max: 100,
                  min: 30,
                  placeholder: "Enter 12th Marks",
                  label: "Enter 12th marks(%)"
                },
                expressionProperties: {
                  "templateOptions.required": () => {
                    if (this.loanService?.studentDetails?.targetDegree !== 'Bachelors') {
                      return true;
                    }
                    return false;
                  }
                },
                validation: {
                  messages: {
                    required: '12th marks required',
                    max: "Percentage should be less than or equal to 100",
                    min: 'Percentage should be more than or equal to 30 and less than 100'
                  },
                },
                hideExpression: () => {
                  return this.step !== 'secondStep'
                },
              },

              {
                className: "col-12 col-lg-6",
                key: "previousDegreeMark",
                type: "input",
                templateOptions: {
                  type: "number",
                  required: true,
                  max: 100,
                  min: 30,
                  placeholder: "Enter Bachelors Marks (%)",
                  label: "Enter bachelors marks (%)"
                },
                validation: {
                  messages: {
                    required: 'Bachelors marks required',
                    max: "Percentage should be less than or equal to 100",
                    min: "Percentage should be greater than or equal to 30"
                  },
                },
                hideExpression: () => {
                  return this.step !== 'secondStep' || this.loanService?.studentDetails?.targetDegree === 'Bachelors'
                }
              },

              {
                className: 'col-12 ms-1 mt-n2',
                template: `<p class="text-primary font-small">If your degree isn't complete, please provide the percentage marks from your latest semester.</p>`,
                hideExpression: () => {
                  return this.step !== 'secondStep';
                }
              },

              {
                className: "col-12 languageExam",
                fieldGroupClassName: "row align-items-end",
                fieldGroup: [
                  {
                    className: 'col-lg-7 col-12',
                    type: 'radio',
                    key: 'aptitudeExam',
                    templateOptions: {
                      required: true,
                      label: "Standardized Test Taken",
                      placeholder: "Select Standardized Test Taken",
                      click: (form, value: any) => {
                        value = value?.target?.value?.split(" ")[1];
                        if (value && value.toString() !== 'false' && value.toString() !== 'undefined') {
                          this.model.academicDetails["aptitudeExamTaken"] = true;
                        }
                        else if (value && value.toString() !== 'undefined') {
                          this.model.academicDetails["aptitudeExamTaken"] = false;
                        }
                      }
                    },
                    expressionProperties: {
                      "templateOptions.options": () => {
                        if (this.model?.targetDegree) {
                          if (this.model?.targetDegree !== 'Bachelors') {
                            return this.aptitudeTestOptions.filter((single) => single?.value !== 'SAT' && single?.value !== 'ACT');
                          } else {
                            return this.aptitudeTestOptions.filter((single) => single?.value !== 'GRE' && single?.value !== 'GMAT')
                          }

                          return this.aptitudeTestOptions
                        }
                      }
                    },
                    hideExpression: () => {
                      if (this.step !== 'thirdStep') {
                        return true;
                      }
                      return false;
                    }
                  },

                  {
                    className: "col-12",
                    fieldGroupClassName: "row",
                    fieldGroup: [
                      {
                        className: "col-12",
                        key: "gmatScore",
                        type: 'input',
                        templateOptions: {
                          //label: 'Aptitude GMAT Score',
                          required: true,
                          type: 'number',
                          max: 800,
                          min: 0,
                          placeholder: 'Enter GMAT score',
                        },
                        hideExpression: () => {
                          if (this.model?.academicDetails?.aptitudeExam != "GMAT" || this.model?.targetDegree === 'Bachelors' || this.step !== 'thirdStep') {
                            return true
                          }
                          return false
                        },
                        validation: {
                          messages: {
                            max: "Score be less than or equal to 800"
                          }
                        }
                      },

                      {
                        className: "col-12",
                        key: "greScore",
                        type: 'input',
                        templateOptions: {
                          //label: 'Aptitude GRE Score',
                          required: true,
                          type: "number",
                          max: 340,
                          min: 0,
                          placeholder: "Enter GRE score"
                        },
                        hideExpression: () => {
                          if (this.model?.academicDetails?.aptitudeExam != "GRE" || this.model?.targetDegree === 'Bachelors' || this.step !== 'thirdStep') {
                            return true
                          }
                          return false
                        },
                        validation: {
                          messages: {
                            max: "Score be less than or equal to 340"
                          }
                        }
                      },

                      {
                        className: 'col-12',
                        key: "satScore",
                        type: 'input',
                        templateOptions: {
                          required: true,
                          max: 1600,
                          min: 0,
                          type: 'number',
                          placeholder: 'Enter SAT Score',
                        },
                        hideExpression: () => {
                          if (this.model?.academicDetails?.aptitudeExam != "SAT" || this.model?.targetDegree != 'Bachelors' || this.step !== 'thirdStep') {
                            return true
                          }
                          return false
                        },
                        validation: {
                          messages: {
                            max: "Score be less than or equal to 1600"
                          }
                        }
                      },

                      {
                        className: 'col-12',
                        key: "actScore",
                        type: 'input',
                        templateOptions: {
                          required: true,
                          max: 36,
                          min: 0,
                          type: 'number',
                          placeholder: 'Enter ACT Score',
                        },
                        hideExpression: () => {
                          if (this.model?.academicDetails?.aptitudeExam != "ACT" || this.model?.targetDegree != 'Bachelors' || this.step !== 'thirdStep') {
                            return true
                          }
                          return false
                        },
                        validation: {
                          messages: {
                            max: "Score be less than or equal to 36"
                          }
                        }
                      },
                    ]
                  }
                ]
              },

              {
                className: 'col-12',
                template: `<hr class="dashed-line">`,
                hideExpression: () => {
                  return this.step !== 'thirdStep';
                }
              },

              {
                className: "col-12 col-md-6 languageExam",
                fieldGroupClassName: "row align-items-end",
                fieldGroup: [
                  {
                    className: 'col-lg-7 col-12',
                    type: 'radio',
                    key: 'languageExam',
                    templateOptions: {
                      required: true,
                      label: "Language Test Taken",
                      options: this.languageTestOptions,
                      placeholder: "Select Language Test Taken",
                      click: (form, value) => {
                        value = value?.target?.value?.split(" ")[1];
                        if (value && value.toString() !== 'false' && value.toString() !== 'undefined') {
                          this.model.academicDetails["languageExamTaken"] = true;
                        }
                        else if (value && value.toString() !== 'undefined') {
                          this.model.academicDetails["languageExamTaken"] = false;
                        }
                      }
                    },
                    hideExpression: () => {
                      return this.step !== 'thirdStep';
                    }
                  },

                  {
                    className: "col-12",
                    fieldGroupClassName: "row",
                    fieldGroup: [
                      {
                        className: 'col-12',
                        key: "toeflScore",
                        type: 'input',
                        templateOptions: {
                          required: true,
                          type: "number",
                          placeholder: 'Enter Score',
                          max: 120,
                          min: 0,
                        },
                        hideExpression: () => {
                          if (this.model?.academicDetails?.languageExam != "TOEFL" || this.step !== 'thirdStep') {
                            return true
                          }
                          return false
                        },
                        validation: {
                          messages: {
                            max: "Score be less than or equal to 120"
                          }
                        }
                      },

                      {
                        className: 'col-12',
                        key: "ieltsScore",
                        type: 'input',
                        templateOptions: {
                          label: '',
                          required: true,
                          type: "number",
                          max: 9,
                          step: 0.5,
                          min: 0,
                          placeholder: "Enter Score"
                        },
                        hideExpression: () => {
                          if (this.model?.academicDetails?.languageExam != "IELTS" || this.step !== 'thirdStep') {
                            return true
                          }
                          return false
                        },
                        asyncValidators: {
                          score: {
                            expression: async (control: any) => {
                              if (control?.value?.toString()?.split('.')[1] === undefined) {
                                return true
                              }
                              else if (control?.value?.toString()?.split('.')[1] !== "5") {
                                return false;
                              }
                              return true;
                            },
                          },
                        },
                        validation: {
                          messages: {
                            max: "Score be less than or equal to 9",
                            score: "Score should be in range of 0.5"
                          }
                        }
                      },

                      {
                        className: 'col-12',
                        key: "detScore",
                        type: 'input',
                        templateOptions: {
                          label: '',
                          required: true,
                          type: "number",
                          max: 160,
                          min: 0,
                          placeholder: "Enter Score"
                        },
                        hideExpression: () => {
                          if (this.model?.academicDetails?.languageExam != "DET" || this.step !== 'thirdStep') {
                            return true
                          }
                          return false
                        },
                        validation: {
                          messages: {
                            max: "Score be less than or equal to 160"
                          }
                        }
                      },

                      {
                        className: 'col-12',
                        key: "pteScore",
                        type: 'input',
                        templateOptions: {
                          required: true,
                          type: "number",
                          max: 90,
                          min: 0,
                          placeholder: 'Enter Score',
                        },
                        hideExpression: () => {
                          if (this.model?.academicDetails?.languageExam != "PTE" || this.step !== 'thirdStep') {
                            return true
                          }
                          return false
                        },
                        validation: {
                          messages: {
                            max: "Score be less than or equal to 90"
                          }
                        }
                      },
                    ]
                  },
                ],

              },
            ]
          },
        ],
        expressionProperties: {
          "fieldGroupClassName": () => {

            if (this.step === "firstStep") {
              return "academic-wrapper row padding-custom custom-height-academic"
            }
            else {
              return "academic-wrapper row padding-custom"
            }
          }
        }
      },
      {
        fieldGroupClassName: 'd-flex justify-content-center justify-content-lg-end padding-custom',
        fieldGroup: [
          {
            className: 'submit-button',
            type: 'button',
            templateOptions: {
              btnType: 'primary px-10 px-lg-8 rounded-1 py-2',
              type: 'submit',
              text: 'Continue  <img src="../../../../assets/logo/next-icon-button.svg" alt="nextIcon">',
              onClick: () => {
                if (this.model?.academicDetails?.previousDegreeMark === undefined || this.model?.academicDetails?.courseType === undefined || this.model?.academicDetails?.admissionStatus === undefined || this.model?.academicDetails?.university === undefined || this.model?.academicDetails?.courseDuration === undefined || this.model?.academicDetails?.languageExam === undefined) {
                  return this.model["error"] = "Hello world";
                }
                else {
                  if (typeof window !== "undefined" && !window.location.host.includes('localhost') && !window.location.host.includes('dev') && !window.location.host.includes('uat')) {
                    this.userData = {
                      source: "Loan Widget",
                    }
                    if (this.loanService.partnerDetails) {

                      this.userData["PartnerName"] = this.loanService.partnerDetails?.company?.name;
                    }
                    this.trackEvent("Next Button of Academic Details on Loan Widget  Clicked", this.userData)
                  }
                }
              }
            },
            expressionProperties: {
              "templateOptions.btnType": (model: any) => {
                if (this.step === "firstStep") {
                  if ([undefined, "", " "].includes(this.model?.academicDetails?.courseType) || [undefined, "", " ",null]?.includes(this.model?.academicDetails?.course) || [undefined, "", " "].includes(this.model?.academicDetails?.admissionStatus) || [undefined, "", " ", null].includes(this.model?.academicDetails?.university) || [undefined, "", " "].includes(this.model?.academicDetails?.courseDuration)) {
                    return "gray disabled w-100 py-3 fw-bold rounded-custom text-white"
                  }
                  else {
                    return "primary w-100 py-3 fw-bold rounded-custom "
                  }
                }
                if (this.step === "secondStep") {
                  if (this.loanService?.studentDetails?.targetDegree !== "Bachelors") {
                    if ([undefined, null, "", " "].includes(this.model?.academicDetails?.twelfthMarks) || [undefined, null, "", " "].includes(this.model?.academicDetails?.previousDegreeMark)) {
                      return "gray disabled w-100 py-3 fw-bold rounded-custom text-white"
                    }
                    else {
                      return "primary w-100 py-3 fw-bold rounded-custom "
                    }

                  }
                  else if (this.loanService?.studentDetails?.targetDegree === "Bachelors") {
                    if ([undefined, null, "", " "].includes(this.model?.academicDetails?.tenthMarks)) {
                      return "gray disabled w-100 py-3 fw-bold rounded-custom text-white"
                    }
                    else {
                      return "primary w-100 py-3 fw-bold rounded-custom "
                    }

                  }

                }
                if (this.step === "thirdStep") {
                  if ([undefined, "", " "].includes(this.model?.academicDetails?.languageExam) || [undefined, "", " "].includes(this.model?.academicDetails?.aptitudeExam)) {
                    return "gray disabled w-100 py-3 fw-bold rounded-custom text-white"
                  }
                  else {
                    return "primary w-100 py-3 fw-bold rounded-custom "
                  }
                }
                else {
                  return "primary w-100 py-3 fw-bold rounded-custom "
                }
              }
            }
          },
        ]
      }
    ]
  }

  setLayout() {
    this.layout = [
      {
        fieldGroup: [
          {
            key: "academicDetails",
            fieldGroupClassName: "row mb-3",
            fieldGroup: [
              {
                className: "col-12",
                fieldGroupClassName: 'row',
                fieldGroup: [
                  {
                    className: 'col-12',
                    key: 'university',
                    type: 'autocomplete',
                    templateOptions: {
                      label: 'University you are planning to go',
                      placeholder: 'Search and Choose',
                      required: true,
                      autocompleteOptions: {
                        name: 'universities',
                        value: 'name',
                        fields: ['name'],
                        dataModel: 'universities',
                        isEditable: true,
                        showTopRecords: true,
                        defaultValue: this.model?.academicDetails?.university,
                        onSelect: (item: any) => {
                          this.model.academicDetails.university = item?.name;
                          if (this.loanService?.studentDetails?.countryCode !== '+91') {
                            if (item?.vendors) {
                              let arr = item?.vendors;
                              arr = arr.filter((single: any) => {
                                return single === 'mpower' || single === 'prodigy';
                              })
                              this.loanService.studentDetails["universityVendors"] = arr;
                              this.checkVendorList(arr)
                            }
                            else {
                              this.loanService.universityBankMessage = "";
                              this.loanService.studentDetails["universityVendors"] = [];
                              delete this.loanService?.studentDetails?.universityVendors;
                            }
                          }
                          else {
                            if (item?.vendors) {
                              this.loanService.studentDetails["universityVendors"] = item?.vendors;
                              this.checkVendorList(item?.vendors)
                            }
                            else {
                              this.loanService.universityBankMessage = "";
                              this.loanService.studentDetails["universityVendors"] = [];
                              // delete this.loanService?.studentDetails?.universityVendors;
                            }
                          }

                        },
                        dataParams: {
                          aggregate: true,
                        },
                      }
                    },
                    expressionProperties: {
                      "templateOptions.autocompleteOptions.dataParams": (model: any) => {
                        let dataParams = {
                          aggregate: true,
                          where: { targetCountry: this.loanService?.studentDetails?.targetCountry },
                          limit: 10
                        }
                        return dataParams
                      }
                    },
                    hideExpression: () => {
                      return this.step !== 'firstStep'
                    }
                  },

                  {
                    className: 'col-12 mt-n2 text-primary',
                    expressionProperties: {
                      "template": () => {
                        if (this.vendorListTemplate)
                          return this.vendorListTemplate;
                      }
                    },
                    hideExpression: () => {
                      if (this.loanService.universityBankMessage && this.step ==='firstStep' && ![undefined, "", " ",null].includes(this.model?.academicDetails?.university) ) {
                        return false;
                      }
                      else {
                        return true;
                      }
                    }
                  },
                ]
              },

              {
                className: "col-12",
                key: "otherUniversity",
                type: "input",
                templateOptions: {
                  required: true,
                  placeholder: "Enter Other University Name",
                  label: "Other University"
                },
                hideExpression: () => {
                  if (this.model?.academicDetails && this.model?.academicDetails?.university) {
                    return this.model.academicDetails.university.toLowerCase() !== "other" || this.step !== 'firstStep'
                  }
                  return true;
                }
              },

              {
                className: 'col-12',
                key: "courseType",
                type: 'radio',
                templateOptions: {
                  label: 'Course Type',
                  required: true,
                  placeholder: "Select course type",
                  options: this.courseTypeOptions,
                  click: () => {
                    setTimeout(() => {
                      if (this.model?.academicDetails?.courseType && this.model?.academicDetails?.courseType != this.currentCourseType) {
                        delete this.loanService?.studentDetails?.academicDetails?.course
                        this.model.academicDetails.course = undefined;
                        this.currentCourseType = this.model?.academicDetails?.courseType;
                        this.loading = true;
                        this.layout = undefined;
                        setTimeout(() => {
                          this.setLayout();
                          this.loading = false;
                        }, 100)
                      }
                    }, 100)
                  }
                },
                validation: {
                  messages: {
                    required: 'Course type is required',
                  },
                },
                hideExpression: () => {
                  return this.step !== 'firstStep'
                }
              },

              {
                className: "col-12",
                fieldGroupClassName: "row",
                fieldGroup: [
                  {
                    className: 'col-12',
                    key: 'course',
                    type: 'autocomplete',
                    templateOptions: {
                      label: 'Course Specialization',
                      placeholder: 'eg. Computer Science',
                      required: true,
                      autocompleteOptions: {
                        name: 'courses',
                        value: 'specialization',
                        fields: ['specialization'],
                        dataModel: 'courses',
                        isEditable: false,
                        showTopRecords: true,
                        defaultValue: this.model?.academicDetails?.course,
                        onSelect: (item: any) => {
                          this.model.academicDetails.course = item?.specialization;
                        }
                      }
                    },
                    expressionProperties: {
                      "templateOptions.autocompleteOptions.dataParams": (model: any) => {
                        if (this.model?.academicDetails?.courseType) {
                          let dataParams = {
                            aggregate: true,
                            where: { studyArea: this.model?.academicDetails?.courseType },
                            limit: 10
                          }
                          return dataParams
                        }
                        return { aggregate: true };

                      }
                    },
                    hideExpression: () => {
                      return this.step !== 'firstStep';
                    }
                  },
                ]
              },

              {
                className: "col-12",
                key: "otherCourse",
                type: "input",
                templateOptions: {
                  label: "Other Course",
                  placeholder: "Enter other course name",
                  required: true
                },
                hideExpression: () => {
                  if (this.model?.academicDetails && this.model?.academicDetails?.course) {
                    return this.model.academicDetails.course.toLowerCase() !== 'other' || this.step !== 'firstStep';
                  }
                  return true;
                }
              },

              {
                className: 'col-12',
                key: "courseDuration",
                type: 'select',
                templateOptions: {
                  label: 'Duration of course',
                  required: true,
                  options: this.courseDurationOptions,
                  placeholder: 'Select course Duration',
                },
                validation: {
                  messages: {
                    required: 'Course duration is required',
                  },
                },
                hideExpression: () => {
                  return this.step !== 'firstStep';
                }
              },

              {
                className: 'col-12',
                key: "admissionStatus",
                type: 'select',
                templateOptions: {
                  label: 'Status of Admission',
                  required: true,
                  options: this.admissionStatusOptions,
                  placeholder: "Select admission status"
                },
                validation: {
                  messages: {
                    required: 'Admission status is required',
                  },
                },
                hideExpression: () => {
                  return this.step !== 'firstStep';
                }
              },

              {
                className: "col-6",
                key: "tenthMarks",
                type: "input",
                templateOptions: {
                  type: "number",
                  // required: true,
                  max: 100,
                  min: 30,
                  placeholder: "Enter 10th Marks",
                  label: "Enter 10th marks(%)"
                },
                validation: {
                  messages: {
                    required: '10th marks required',
                    max: "Percentage should be less than or equal to 100",
                    min: 'Percentage should be more than or equal to 30 and less than 100'
                  },
                },
                hideExpression: () => {
                  return this.step !== 'secondStep';
                },
                expressionProperties: {
                  "templateOptions.required": () => {
                    if (this.loanService?.studentDetails?.targetDegree === "Bachelors") {
                      return true;
                    }
                    else {
                      return false;
                    }
                  }
                }
              },

              {
                className: "col-6",
                key: "twelfthMarks",
                type: "input",
                templateOptions: {
                  type: "number",
                  max: 100,
                  min: 30,
                  placeholder: "Enter 12th Marks",
                  label: "Enter 12th marks(%)"
                },
                expressionProperties: {
                  "templateOptions.required": () => {
                    if (this.loanService?.studentDetails?.targetDegree !== 'Bachelors') {
                      return true;
                    }
                    return false;
                  }
                },
                validation: {
                  messages: {
                    required: '12th marks required',
                    max: "Percentage should be less than or equal to 100",
                    min: 'Percentage should be more than or equal to 30 and less than 100'
                  },
                },
                hideExpression: () => {
                  return this.step !== 'secondStep'
                },
              },

              {
                className: "col-12",
                key: "previousDegreeMark",
                type: "input",
                templateOptions: {
                  type: "number",
                  required: true,
                  max: 100,
                  min: 30,
                  placeholder: "Enter Bachelors Marks (%)",
                  label: "Enter bachelors marks (%)"
                },
                validation: {
                  messages: {
                    required: 'Bachelors marks required',
                    max: "Percentage should be less than or equal to 100",
                    min: "Percentage should be greater than or equal to 30"
                  },
                },
                hideExpression: () => {
                  return this.step !== 'secondStep' || this.loanService?.studentDetails?.targetDegree === 'Bachelors'
                }
              },

              {
                className: 'col-12 ms-1 mt-n2',
                template: `<p class="text-primary font-small">If your degree isn't complete, please provide the percentage marks from your latest semester.</p>`,
                hideExpression: () => {
                  return this.step !== 'secondStep';
                }
              },

              {
                className: "col-12 languageExam",
                fieldGroupClassName: "row align-items-end",
                fieldGroup: [
                  {
                    className: 'col-lg-7 col-12',
                    type: 'radio',
                    key: 'aptitudeExam',
                    templateOptions: {
                      required: true,
                      label: "Standardized Test Taken",
                      placeholder: "Select Standardized Test Taken",
                      click: (form, value: any) => {
                        value = value?.target?.value?.split(" ")[1];
                        if (value && value.toString() !== 'false' && value.toString() !== 'undefined') {
                          this.model.academicDetails["aptitudeExamTaken"] = true;
                        }
                        else if (value && value.toString() !== 'undefined') {
                          this.model.academicDetails["aptitudeExamTaken"] = false;
                        }
                      }
                    },
                    expressionProperties: {
                      "templateOptions.options": () => {
                        if (this.model?.targetDegree) {
                          if (this.model?.targetDegree !== 'Bachelors') {
                            return this.aptitudeTestOptions.filter((single) => single?.value !== 'SAT' && single?.value !== 'ACT');
                          } else {
                            return this.aptitudeTestOptions.filter((single) => single?.value !== 'GRE' && single?.value !== 'GMAT')
                          }

                          return this.aptitudeTestOptions
                        }
                      }
                    },
                    hideExpression: () => {
                      if (this.step !== 'thirdStep') {
                        return true;
                      }
                      return false;
                    }
                  },

                  {
                    className: "col-12",
                    fieldGroupClassName: "row",
                    fieldGroup: [
                      {
                        className: "col-12",
                        key: "gmatScore",
                        type: 'input',
                        templateOptions: {
                          //label: 'Aptitude GMAT Score',
                          required: true,
                          type: 'number',
                          max: 800,
                          min: 0,
                          placeholder: 'Enter GMAT score',
                        },
                        hideExpression: () => {
                          if (this.model?.academicDetails?.aptitudeExam != "GMAT" || this.model?.targetDegree === 'Bachelors' || this.step !== 'thirdStep') {
                            return true
                          }
                          return false
                        },
                        validation: {
                          messages: {
                            max: "Score be less than or equal to 800"
                          }
                        }
                      },

                      {
                        className: "col-12",
                        key: "greScore",
                        type: 'input',
                        templateOptions: {
                          //label: 'Aptitude GRE Score',
                          required: true,
                          type: "number",
                          max: 340,
                          min: 0,
                          placeholder: "Enter GRE score"
                        },
                        hideExpression: () => {
                          if (this.model?.academicDetails?.aptitudeExam != "GRE" || this.model?.targetDegree === 'Bachelors' || this.step !== 'thirdStep') {
                            return true
                          }
                          return false
                        },
                        validation: {
                          messages: {
                            max: "Score be less than or equal to 340"
                          }
                        }
                      },

                      {
                        className: 'col-12',
                        key: "satScore",
                        type: 'input',
                        templateOptions: {
                          required: true,
                          max: 1600,
                          min: 0,
                          type: 'number',
                          placeholder: 'Enter SAT Score',
                        },
                        hideExpression: () => {
                          if (this.model?.academicDetails?.aptitudeExam != "SAT" || this.model?.targetDegree != 'Bachelors' || this.step !== 'thirdStep') {
                            return true
                          }
                          return false
                        },
                        validation: {
                          messages: {
                            max: "Score be less than or equal to 1600"
                          }
                        }
                      },

                      {
                        className: 'col-12',
                        key: "actScore",
                        type: 'input',
                        templateOptions: {
                          required: true,
                          max: 36,
                          min: 0,
                          type: 'number',
                          placeholder: 'Enter ACT Score',
                        },
                        hideExpression: () => {
                          if (this.model?.academicDetails?.aptitudeExam != "ACT" || this.model?.targetDegree != 'Bachelors' || this.step !== 'thirdStep') {
                            return true
                          }
                          return false
                        },
                        validation: {
                          messages: {
                            max: "Score be less than or equal to 36"
                          }
                        }
                      },
                    ]
                  }
                ]
              },

              {
                className: 'col-12',
                template: `<hr class="dashed-line">`,
                hideExpression: () => {
                  return this.step !== 'thirdStep';
                }
              },

              {
                className: "col-12 languageExam",
                fieldGroupClassName: "row align-items-end",
                fieldGroup: [
                  {
                    className: 'col-12',
                    type: 'radio',
                    key: 'languageExam',
                    templateOptions: {
                      required: true,
                      label: "Language Test Taken",
                      options: this.languageTestOptions,
                      placeholder: "Select Language Test Taken",
                      click: (form, value) => {
                        value = value?.target?.value?.split(" ")[1];
                        if (value && value.toString() !== 'false' && value.toString() !== 'undefined') {
                          this.model.academicDetails["languageExamTaken"] = true;
                        }
                        else if (value && value.toString() !== 'undefined') {
                          this.model.academicDetails["languageExamTaken"] = false;
                        }
                      }
                    },
                    hideExpression: () => {
                      return this.step !== 'thirdStep';
                    }
                  },

                  {
                    className: "col-12",
                    fieldGroupClassName: "row",
                    fieldGroup: [
                      {
                        className: 'col-12',
                        key: "toeflScore",
                        type: 'input',
                        templateOptions: {
                          required: true,
                          type: "number",
                          placeholder: 'Enter Score',
                          max: 120,
                          min: 0,
                        },
                        hideExpression: () => {
                          if (this.model?.academicDetails?.languageExam != "TOEFL" || this.step !== 'thirdStep') {
                            return true
                          }
                          return false
                        },
                        validation: {
                          messages: {
                            max: "Score be less than or equal to 120"
                          }
                        }
                      },

                      {
                        className: 'col-12',
                        key: "ieltsScore",
                        type: 'input',
                        templateOptions: {
                          label: '',
                          required: true,
                          type: "number",
                          max: 9,
                          step: 0.5,
                          min: 0,
                          placeholder: "Enter Score"
                        },
                        hideExpression: () => {
                          if (this.model?.academicDetails?.languageExam != "IELTS" || this.step !== 'thirdStep') {
                            return true
                          }
                          return false
                        },
                        asyncValidators: {
                          score: {
                            expression: async (control: any) => {
                              if (control?.value?.toString()?.split('.')[1] === undefined) {
                                return true
                              }
                              else if (control?.value?.toString()?.split('.')[1] !== "5") {
                                return false;
                              }
                              return true;
                            },
                          },
                        },
                        validation: {
                          messages: {
                            max: "Score be less than or equal to 9",
                            score: "Score should be in range of 0.5"
                          }
                        }
                      },

                      {
                        className: 'col-12',
                        key: "detScore",
                        type: 'input',
                        templateOptions: {
                          label: '',
                          required: true,
                          type: "number",
                          max: 160,
                          min: 0,
                          placeholder: "Enter Score"
                        },
                        hideExpression: () => {
                          if (this.model?.academicDetails?.languageExam != "DET" || this.step !== 'thirdStep') {
                            return true
                          }
                          return false
                        },
                        validation: {
                          messages: {
                            max: "Score be less than or equal to 160"
                          }
                        }
                      },

                      {
                        className: 'col-12',
                        key: "pteScore",
                        type: 'input',
                        templateOptions: {
                          required: true,
                          type: "number",
                          max: 90,
                          min: 0,
                          placeholder: 'Enter Score',
                        },
                        hideExpression: () => {
                          if (this.model?.academicDetails?.languageExam != "PTE" || this.step !== 'thirdStep') {
                            return true
                          }
                          return false
                        },
                        validation: {
                          messages: {
                            max: "Score be less than or equal to 90"
                          }
                        }
                      },
                    ]
                  },
                ],

              },
            ]
          },
        ],
        expressionProperties: {
          "fieldGroupClassName": () => {

            if (this.step === "firstStep") {
              return "academic-wrapper row padding-custom custom-height-academic-web"
            }
            else {
              return "academic-wrapper row padding-custom"
            }
          }
        }
      },
      {
        fieldGroupClassName: 'col-12 padding-custom',
        fieldGroup: [
          {
            className: 'submit-button',
            type: 'button',
            templateOptions: {
              btnType: 'primary px-10 rounded-1 py-2',
              type: 'submit',
              text: 'Continue  <img src="../../../../assets/logo/next-icon-button.svg" alt="nextIcon">',
              onClick: () => {
                if (this.model?.academicDetails?.previousDegreeMark === undefined || this.model?.academicDetails?.courseType === undefined || this.model?.academicDetails?.admissionStatus === undefined || this.model?.academicDetails?.university === undefined || this.model?.academicDetails?.courseDuration === undefined || this.model?.academicDetails?.languageExam === undefined) {
                  return this.model["error"] = "Hello world";
                }
                else {
                  if (typeof window !== "undefined" && !window.location.host.includes('localhost') && !window.location.host.includes('dev') && !window.location.host.includes('uat')) {
                    this.userData = {
                      source: "Loan Widget",
                    }
                    if (this.loanService.partnerDetails) {

                      this.userData["PartnerName"] = this.loanService.partnerDetails?.company?.name;
                    }
                    this.trackEvent("Next Button of Academic Details on Loan Widget  Clicked", this.userData)
                  }
                }
              }
            },
            expressionProperties: {
              "templateOptions.btnType": (model: any) => {
                if (this.step === "firstStep") {
                  if ([undefined, "", " "].includes(this.model?.academicDetails?.courseType)|| [undefined, "", " ",null]?.includes(this.model?.academicDetails?.course) || [undefined, "", " "].includes(this.model?.academicDetails?.admissionStatus) || [undefined, "", " ",null].includes(this.model?.academicDetails?.university) || [undefined, "", " "].includes(this.model?.academicDetails?.courseDuration)) {
                    return "gray disabled w-100 py-3 fw-bold rounded-custom text-white"
                  }
                  else {
                    return "primary w-100 py-3 fw-bold rounded-custom "
                  }
                }
                if (this.step === "secondStep") {
                  if (this.loanService?.studentDetails?.targetDegree !== "Bachelors") {
                    if ([undefined, null, "", " "].includes(this.model?.academicDetails?.twelfthMarks) || [undefined, null, "", " "].includes(this.model?.academicDetails?.previousDegreeMark)) {
                      return "gray disabled w-100 py-3 fw-bold rounded-custom text-white"
                    }
                    else {
                      return "primary w-100 py-3 fw-bold rounded-custom "
                    }

                  }
                  else if (this.loanService?.studentDetails?.targetDegree === "Bachelors") {
                    if ([undefined, null, "", " "].includes(this.model?.academicDetails?.tenthMarks)) {
                      return "gray disabled w-100 py-3 fw-bold rounded-custom text-white"
                    }
                    else {
                      return "primary w-100 py-3 fw-bold rounded-custom "
                    }

                  }

                }
                if (this.step === "thirdStep") {
                  if ([undefined, "", " "].includes(this.model?.academicDetails?.languageExam) || [undefined, "", " "].includes(this.model?.academicDetails?.aptitudeExam)) {
                    return "gray disabled w-100 py-3 fw-bold rounded-custom text-white"
                  }
                  else {
                    return "primary w-100 py-3 fw-bold rounded-custom "
                  }
                }
                else {
                  return "primary w-100 py-3 fw-bold rounded-custom "
                }
              }
            }
          },
        ]
      }
    ]
  }

  checkVendorList(vendors) {
    this.vendorListTemplate = "";
    let universityVendors: string = "";
    if (vendors) {
      for (let i = 0; i < vendors.length; i++) {
        if (i != vendors.length - 1) {
          universityVendors += `${vendors[i]}, `;
        }
        else {
          universityVendors += `${vendors[i]}`;
        }
      }
      if(universityVendors){
        this.vendorListTemplate = `<p>Listed in ${universityVendors.toUpperCase()}</p>`;
        this.loanService.universityBankMessage = this.vendorListTemplate;
      }
    }
    else {
      this.vendorListTemplate = "";
      universityVendors = "";
    }
  }

  getPartnerDetails(partnerUid: string) {
    this.apiHelper.getDataById("users/partner", partnerUid)?.subscribe({
      next: (response: any) => {
        // Handle successful response
        let partnerDetails = { ...response };
        localStorage.setItem('puid', partnerUid);
        this.loanService.studentDetails.parentId = partnerDetails?.id;
        this.loanService.studentDetails.puid = partnerDetails?.uid;
        this.loanService.partnerDetails = { ...partnerDetails };
        this.loanService.studentDetails.puid = partnerDetails?.uid;
        this.partnerLogo = partnerDetails?.company?.showCompanyLogo ? partnerDetails?.company?.logo : undefined;
        this.layout = undefined;
        let newModel = { ...this.model };
        this.model = undefined;
        this.model = { ...newModel }
        if (this.orientation === 'horizontal') {
          this.setLayout();
        }
        else {
          this.setMobileLayout();
        }
      },
      error: (error: any) => {
        this.route.navigate(['/academic-details'])
        this.isPartnerLink = false;
      }
    });

  }

  checkUserLoggedIn() {
    if (!this.loanService.studentDetails?.mobile) {
      if (this.isPartnerLink) {
        this.route.navigate([this.loanService?.partnerDetails?.uid]);
        return;
      }
      this.route.navigate(['']);
    }
    else if (!this.userIdentity.isLoggedIn.getValue()) {
      if (this.isPartnerLink) {
        this.route.navigate(['personal-details/' + this.loanService?.partnerDetails?.uid]);
        return;
      }
      this.route.navigate(['/personal-details']);
    }
    this.dataPreprocessor();
  }

  dataPreprocessor() {
    this.model = { ...this.loanService.studentDetails };
    if (this.model?.academicDetails && (this.loanService?.studentDetails?.academicDetails?.greScore || this.loanService?.studentDetails?.academicDetails?.gmatScore || this.loanService?.studentDetails?.academicDetails?.satScore || this.loanService?.studentDetails?.academicDetails?.actScore)) {
      this.model.academicDetails.aptitudeExamTaken = true;
    }
    if (this.model?.academicDetails && (this.model?.academicDetails?.ieltsScore || this.model?.academicDetails?.toeflScore || this?.model?.academicDetails?.pteScore || this?.model?.academicDetails?.detScore)) {
      this.model.academicDetails.languageExamTaken = true;
    } if (this.model?.academicDetails) {
      if (this.model?.academicDetails?.languageExamTaken) {
        if (this.model?.academicDetails?.ieltsScore) {
          this.model.academicDetails["languageExam"] = "IELTS"
        }
        else if (this.model?.academicDetails?.toeflScore) {
          this.model.academicDetails["languageExam"] = "TOEFL"
        }
        else if (this?.model?.academicDetails?.pteScore) {
          this.model.academicDetails["languageExam"] = "PTE"
        }
        else if (this?.model?.academicDetails?.detScore) {
          this.model.academicDetails["languageExam"] = "DET"
        }
      }
      else {
        this.model.academicDetails["languageExam"] = false;
      }

      if (this.model?.academicDetails?.aptitudeExamTaken) {
        if (this.model?.academicDetails?.greScore) {
          this.model.academicDetails["aptitudeExam"] = "GRE"
        }
        else if (this.model?.academicDetails?.gmatScore) {
          this.model.academicDetails["aptitudeExam"] = "GMAT"
        }
        else if (this.model?.academicDetails?.satScore) {
          if (this.model?.targetDegree == 'Bachelors') {
            this.model.academicDetails["aptitudeExam"] = "SAT"
          }
        }

        else if (this.model?.academicDetails?.actScore) {
          if (this.model?.targetDegree == 'Bachelors') {
            this.model.academicDetails["aptitudeExam"] = "ACT"
          }
        }
      }
      else {
        this.model.academicDetails["aptitudeExam"] = false;
      }
    }

    if (this.model?.academicDetails?.courseType) {
      this.currentCourseType = this.model?.academicDetails?.courseType
    }

    if (this.orientation === 'horizontal') {
      this.setLayout();
    }
    else {
      this.setMobileLayout();
    }

    this.setUniversityVendors();
    // delete this.model?.universityVendors
  }

  dataProcessor(data: any) {
    delete data?.academicDetails?.languageExam;
    delete data?.academicDetails?.aptitudeExam;
    if (data?.error) {
      delete data?.error;
      this.model.error = undefined;
    }
    delete data?.universityVendors;

    data = this.loanService.removeEmpty(data);
    if (this.loanService.studentDetails?.targetDegree === "Bachelors") {
      data.previousDegreeMark = data.tenthMarks;
    }
    return data;
  }

  onSubmit(event: any) {
    if (!event?.error) {
      delete this.model.universityVendors;
      this.loanService.saveStudentDetails(this.model).then(() => {
        if (this.step === 'firstStep') {
          this.step = 'secondStep';

          this.configAcademicDetailsHeader.title = "Academic Details";
          this.steps.steps[1].status = "completed";
          this.configAcademicDetailsHeader.back = {
            link: '/academic-details',
            step: 'firstStep'
          }
        }
        else if (this.step === 'secondStep') {
          this.step = 'thirdStep';
          this.steps.steps[2].status = "completed";
          this.configAcademicDetailsHeader.title = "Your Aptitude Scores",
            this.configAcademicDetailsHeader.back = {
              link: '/academic-details',
              step: 'secondStep'
            }
        }
        else if (this.step === 'thirdStep') {
          if (this.isPartnerLink) {
            this.route.navigate(['loan-details/' + this.loanService?.partnerDetails?.uid]);
            return;
          }
          this.route.navigate(['loan-details']);
        }
        this.dataPreprocessor();

      })

      gtag('event', 'academic_details_submit', {
        'event_category': 'button',
        'event_label': 'Academic details submit button',
        'value': "Academic details information"  
      });

      gtag('config','G-LW5LDX8EDG',{
        'user_id': this.model?.mobile
      })
    }
  }

  back() {
    if (this.isPartnerLink) {
      this.route.navigate(['personal-details/' + this.loanService?.partnerDetails?.uid]);
      return;
    }
    this.route.navigate(['personal-details'])
  }

  logout() {
    if (this.isPartnerLink) {
      this.route.navigate(['/' + this.loanService?.partnerDetails?.uid]);
      return;
    }
    this.route.navigate(['/'])
  }

  emitStep(ev: any) {
    if (this.step === 'firstStep') {
      let newModel = { ...this.model };
      this.model = undefined;
      this.model = newModel;
      this.step = ev.step;
      if (this.isPartnerLink) {
        this.route.navigate(['basic-information/' + this.loanService?.partnerDetails?.uid]);
        return;
      }
      this.route.navigate(['basic-information']);
    }
    else if (this.step === 'secondStep') {
      let newModel = { ...this.model };
      this.model = undefined;
      this.model = newModel;
      this.step = 'firstStep';
      this.steps.steps[0].status = "completed"
      this.steps.steps[1].status = "completed"
      this.steps.steps[2].status = "progress"
      this.configAcademicDetailsHeader.title = "University and Course Details",
        this.configAcademicDetailsHeader.back = {
          link: '/academic-details',
          step: 'firstStep'
        }
      if (this.isPartnerLink) {
        this.route.navigate([ev.link + "/" + this.loanService?.partnerDetails?.uid]);
        return;
      }

      this.route.navigate([ev.link]);

    }
    else if (this.step === 'thirdStep') {

      this.steps.steps[0].status = "completed"
      this.steps.steps[1].status = "completed"
      this.steps.steps[2].status = "completed"
      let newModel = { ...this.model };
      this.model = undefined;
      this.model = newModel;
      this.step = ev.step;

      this.configAcademicDetailsHeader.title = "Academic Details",
        this.configAcademicDetailsHeader.back = {
          link: '/academic-details',
          step: 'secondStep'
        }
      if (this.isPartnerLink) {
        this.route.navigate([ev.link + "/" + this.loanService?.partnerDetails?.uid]);
        return;
      }
      this.route.navigate([ev.link]);

    }
    this.dataPreprocessor();
  }
}
